import DOMPurify from "dompurify"

const ALLOWED_TAGS = [
    "p",
    "br",
    "div",
    "span",
    "ul",
    "ol",
    "li",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "s",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "a",
    "img",
    "figure",
    "figcaption",
    "blockquote",
    "hr",
    "table",
    "thead",
    "tbody",
    "tr",
    "th",
    "td",
]
const ALLOWED_ATTRIBUTES = ["href", "title", "src", "alt", "width", "height", "colspan", "rowspan"]

// Links open in a new tab and never inherit our window (DOMPurify already drops unsafe schemes),
// and images load lazily since third-party content can carry several.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
        node.setAttribute("target", "_blank")
        node.setAttribute("rel", "noopener noreferrer")
    } else if (node.tagName === "IMG") {
        node.setAttribute("loading", "lazy")
    }
})

/**
 * Reduce third-party HTML to the formatting subset that is safe to render.
 *
 * Markup is sanitized down to text formatting, lists, headings, links, images, and tables —
 * no inline styles, scripts, embeds, or event handlers — before it reaches the DOM. Content
 * with no markup at all keeps its line breaks.
 */
export default function sanitizeHtml(html: string): string {
    const hasMarkup = /<[a-z][^>]*>/i.test(html)
    const markup = hasMarkup ? html : html.replace(/\n/g, "<br>")

    return DOMPurify.sanitize(markup, {
        ALLOWED_TAGS,
        ALLOWED_ATTR: ALLOWED_ATTRIBUTES,
    })
}
